<div *ngIf="relation$ | async" [formGroup]="form" class="locations-form">
    <cyno-field class="locations-form__field">
        <cyno-label>Uw postcode</cyno-label>
        <input cynoInput formControlName="postcode" id="postcode" maxlength="6" type="text" />
        <button (click)="onChangePostalCode()" [disabled]="changePostcodeButtonDisabled" class="btn btn--more">
            Wijzig
        </button>
    </cyno-field>
    <div class="locations-form__error">
        <cyno-error *ngIf="postcode.touched && postcode.invalid">Vul uw postcode in.</cyno-error>
    </div>

    <hr />

    <div *ngIf="loading" class="locations-form__loading">
        <p>Klein momentje, de vestigingen worden voor u uitgekozen...</p>
    </div>

    <ng-container *ngIf="notifications.length > 0">
        <cyno-alert [notifications]="notifications"></cyno-alert>
        <br />
    </ng-container>

    <div *ngIf="locationSubset.length > 0" class="form-group form-group-radio">
        <span class="locations-form__radio-header">Kies een vestiging</span>
        <div class="radio-list__card locations-form__card">
            <div
                *ngFor="let location of locationSubset"
                class="radio-list__card-container locations-form__card-container"
                [class.radio-list__card-container--active]="location.business_relation_id == addressRelationId"
            >
                <input
                    (click)="onAddressRelationChange($event)"
                    [id]="'adres_relatie_id' + location.business_relation_id"
                    [value]="location.business_relation_id"
                    formControlName="adres_relatie_id"
                    type="radio"
                    class="radio"
                />
                <label [for]="'adres_relatie_id' + location.business_relation_id" class="radio-list__card-label">
                    <span class="radio-list__card-title">{{ location.name }}</span>
                    <span class="radio-list__card-content">
                        <span class="radio-list__card-content-item">
                            {{ location.street_name }} {{ location.civic_number }}
                        </span>
                        <span class="radio-list__card-content-item">
                            {{ location.postal_code }} {{ location.city }}
                        </span>
                        <span class="radio-list__card-content-item radio-list__card-content-item--icon">
                            <svg class="svg-icon svg-icon--xs">
                                <use href="assets/icons-ui.svg#location"></use>
                            </svg>
                            {{ location.distance | kilometer }} km
                        </span>
                    </span>
                </label>
            </div>
        </div>
        <div *ngIf="locationSubset.length > 3 && damageRepairCode !== 'GLSH'" class="radio-list__card-read-more">
            <button (click)="onShowMoreClick()" *ngIf="locationDiff > 0" class="btn btn--more">
                Toon meer ({{ locationDiff }})
                <svg class="svg-icon svg-icon--xs">
                    <use href="assets/icons-ui.svg#pijl-down-bold"></use>
                </svg>
            </button>
            <button (click)="onShowLessClick()" *ngIf="locationDiff < 1" class="btn btn--more">
                Toon minder
                <svg class="svg-icon svg-icon--xs">
                    <use href="assets/icons-ui.svg#pijl-down-bold"></use>
                </svg>
            </button>
        </div>
    </div>
    <hr />
</div>
